import { plainToInstance } from 'class-transformer';
export function plainToModel(cls, plain, options) {
    return plainToInstance(cls, plain, {
        enableImplicitConversion: true,
        enableCircularCheck: true,
        ...options,
    });
}
